module.exports = __webpack_public_path__ + "img/lp-icon.f0307216.png";